<template id="resetPassword">
  <div class="container float-page">
    <!-- Float Box -->
    <div class="float-box">
      <div class="card">
        <!-- Float Card Body -->
        <div class="card-body float-card-body">
          <h1 class="mb-3"> {{ $t('Customer.resetPassword.reset_password') }}</h1>
          <p class="float-box-msg mb-2"> {{ $t('Customer.resetPassword.resetpassword') }}</p>
          <el-form :model="resetModel" :rules="resetRules" ref="resetForm">
            <el-form-item prop="newPassword">
              <el-input
                v-model="resetModel.newPassword"
                :placeholder="$t('Customer.resetPassword.newwpd')"
                type="password"
                suffix-icon="fas fa-lock fa-sm"
              ></el-input>
            </el-form-item>
            <el-form-item prop="repeatPassword">
              <el-input
                v-model="resetModel.repeatPassword"
                type="password"
                suffix-icon="fas fa-lock fa-sm"
                :placeholder="$t('Customer.resetPassword.repeatPassword')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                class="btn btn-block btn-primary btn-lg"
                @click="resetPassword('resetForm')"
                > {{ $t('Customer.resetPassword.reset_password') }}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- /.float-card-body -->
      </div>
    </div>
    <!-- /.float-box -->
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    var checkPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('Customer.resetPassword.error1')));
      } else if (value !== this.resetModel.newPassword) {
        return callback(new Error(this.$t('Customer.resetPassword.error2')));
      } else {
        callback();
      }
    };
    return {
      key: null,
      resetModel: {
        newPassword: null,
        repeatPassword: null,
      },
      resetRules: {
        newPassword: [
          { required: true, message: "請輸入新密碼", trigger: "blur" },
        ],
        repeatPassword: [{ validator: checkPass, trigger: "blur" }],
      },
    };
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 0);
    this.key = this.$route.query.key;
  },
  methods: {
    resetPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (
          valid &&
          this.resetModel.newPassword == this.resetModel.repeatPassword
        ) {
          //驗證通過
          let params = {
            password: this.resetModel.newPassword,
            key:this.key,
          };
          //請求
          this.$api.common.resetPassWord(params).then((res) => {
            if (res.data.success) {
              Message({ type: "success", message: "重置成功" });
              //跳轉
              this.$router.push({ name: "resetPwSuccess" });
            }else{
                Message({ type: 'error', message: "重置失敗" });
            }
          });
        } else {
          Message({
            type: "error",
            message: "請檢查必填項信息是否一致",
          });
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Customer/resetPassword.vue